import React from 'react'
import { useSelector } from 'react-redux'

import { getUserLevel, getUserLevelPercent } from 'utils'
import { CircularProgressBar } from '@astrid/components'
import { selectCurrentUser } from 'store/services/User'

import './Level.scss'

const Level: React.FC = () => {
  const globalScore = useSelector(selectCurrentUser)?.profile.globalScore ?? 0
  const userLevel = getUserLevel(globalScore)
  const levelPercentage = getUserLevelPercent(globalScore)

  return (
    <div
      className="level"
      role="progressbar"
      aria-label={`Level ${userLevel}`}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(levelPercentage)}
    >
      <CircularProgressBar
        backgroundColor="#18acb7"
        progressColor="#6fe2dc"
        percentage={levelPercentage}
        size={24}
        strokeWidth={5}
        aria-hidden="true"
      />
      <span className="level__text">
        <span className="level__text--disapearing">Level</span>
        {userLevel}
      </span>
    </div>
  )
}
export default Level
